/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

import store from "features/store";

export function MyAccountMenuList() {
    const menuList = [
        {
            name: 'Become a Premier Member',
            include: '/my-account/join-premier-member',
            path: '/my-account/join-premier-member',
        },
        {
            name: 'My Premier Benefits ',
            include: 'my-account/premier',
            path: '/my-account/premier/member-benefits',
            sub_menu: [
                // {
                //     name: 'Member Benefits',
                //     include:'/member-benefits',
                //     path: '/my-account/premier/member-benefits'
                // },
                // {
                //     name: 'Make It Returnable',
                //     include: '/make-it-returnable',
                //     path: '/my-account/premier/make-it-returnable'
                // },
                {
                    name: 'Delivery Guarantee',
                    include: '/delivery-guarantee',
                    path: '/my-account/premier/delivery-guarantee'
                },
                {
                    name: `Total Access`,
                    include: '/total-access',
                    path: '/my-account/premier/total-access'
                },
                {
                    name: 'WorthPoint',
                    include: '/worthpoint',
                    path: '/my-account/premier/worthpoint'
                },
                {
                    name: 'Auction Sneak Peek',
                    include: '/auction-sneak-peak',
                    path: '/my-account/premier/auction-sneak-peak'
                },
                {
                    name: 'Premier Advisor',
                    include: '/advisor',
                    path: '/my-account/premier/advisor',
                },
                {
                    name: 'Premier Account',
                    include: '/premier-account',
                    path: '/my-account/premier/premier-account'
                },             
                {
                    name: `Alzheimer's Foundation`,
                    include: '/alzheimers-foundation',
                    path: '/my-account/premier/alzheimers-foundation'
                },
                
            ]
        },
        {
            name: 'My Info',
            include: '/my-info',
            path: '/my-account/my-info/personal-info',
            sub_menu: [
                {
                    name: 'Personal Info',
                    include: '/personal-info',
                    path: '/my-account/my-info/personal-info'
                },
                {
                    name: 'Personal Interests',
                    include: '/personal-interests',
                    path: '/my-account/my-info/personal-interests'
                },
                {
                    name: 'Payment Methods',
                    include: '/payment-methods',
                    path: '/my-account/my-info/payment-methods'
                },
                {
                    name: 'Change Password',
                    include: '/change-password',
                    path: '/my-account/my-info/change-password'
                },
                {
                    name: 'Tax Exemptions',
                    include: '/tax-exemptions',
                    path: '/my-account/my-info/tax-exemptions'
                },
                {
                    name: 'Delete Your CTBids Account',
                    include: '/delete-account',
                    path: '/my-account/my-info/delete-account'
                },
            ]
        },
        {
            name: 'Invoices/Receipts',
            include: '/my-account/invoice',
            path: '/my-account/invoice',
            sub_menu: [
                {
                    name: 'Shipped Items',
                    include: '/shipped-items',
                    path: '/my-account/invoice/shipped-items'
                },
            ]
        },

        {
            name: 'Make It Returnable Status',
            include: '/my-account/mir',
            path: '/my-account/mir',
        },
        {
            name: 'Delivery Guarantee Status',
            include: '/my-account/gd',
            path: '/my-account/gd',
        },
        {
            name: 'Notification',
            include: '/my-account/notification-preferences',
            path: '/my-account/notification-preferences',
        }
    ];
    return menuList;
}

export const ToggleSideBar = () => {
    store.dispatch({ type: 'SET_SIDEBAR', payload: window.innerWidth > 992 });
}

export const removeSideBar = () => {
    store.dispatch({ type: 'SET_SIDEBAR', payload: false });
}

export const windowResizeListenerAdd = () => {
    window.addEventListener('resize', ToggleSideBar);
}

export const windowResizeListenerRemove = () => {
    window.removeEventListener('resize', ToggleSideBar);
}